import { Store, Building2, Briefcase, MapPinned } from "lucide-react";
import { Reveal } from "./Reveal";

const GROUPS = [
  {
    icon: Briefcase,
    title: "Inwestorzy prywatni i instytucjonalni",
    desc: "Poszukujący nieruchomości lub partnera prowadzącego inwestycję.",
  },
  {
    icon: Building2,
    title: "Deweloperzy",
    desc: "Poszukujący gruntów i nowych projektów inwestycyjnych.",
  },
  {
    icon: Store,
    title: "Sieci handlowe i usługowe",
    desc: "Poszukujące nowych lokalizacji do rozwoju w regionie.",
  },
  {
    icon: MapPinned,
    title: "Właściciele gruntów i nieruchomości",
    desc: "Chcący zwiększyć wartość nieruchomości albo znaleźć inwestora lub najemcę.",
  },
];

export const ForWhom = () => (
  <section id="dla-kogo" data-testid="for-whom-section" className="py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <Reveal className="mb-16">
        <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-[#8C6D46]">
          Dla kogo
        </p>
        <h2 className="max-w-xl font-serif text-2xl font-semibold leading-tight tracking-tight text-slate-950 sm:text-3xl lg:text-4xl">
          Dla kogo pracuję?
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {GROUPS.map((g, i) => (
          <Reveal key={g.title} delay={0.08 * i}>
            <div
              data-testid={`for-whom-card-${i + 1}`}
              className="group h-full rounded-sm border border-slate-200 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-[#8C6D46]/50"
            >
              <div className="mb-10 flex h-12 w-12 items-center justify-center rounded-full border border-slate-200 text-slate-500 transition-colors duration-300 group-hover:border-[#8C6D46] group-hover:text-[#8C6D46]">
                <g.icon size={20} strokeWidth={1.6} />
              </div>
              <h3 className="font-serif text-xl font-medium leading-snug text-slate-900">{g.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{g.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
